export const ReducerUtils = {
  cards: {
    list: "CARDS_LIST",
  },
  claims: {
    list: "CLAIMS_LIST",
    count: "CLAIMS_COUNT",
    perPage: 10,
    remarks: "CLAIMS_REMARKS"
  },
  filter: {
    customDateRange: "CUSTOM_DATE_RANGE",
    duration: "FILTER_DURATION",
    status: "FILTER_STATUS",
  },
  order: {
    details: "ORDER_DETAILS",
  },
  products: {
    config: "PRODUCT_CONFIG",
  },
  search: {
    text: "SEARCH_TEXT",
  },
  profile: {
    details: "PROFILE_DETAILS"
  }
};
